import axios from "./httpClient";
import { ApiType } from "./Types";
import { getUrl } from "./getURL";
import { ErrorMessages } from "../constants";
import { MisdeliveryFormData } from "../models";
import { throwApiError } from "./apiError";
import { getTrackingHeadersMap } from "./getTrackingHeaders";

/**
 * CRETE API call using Axios
 * @returns - Create Misdelivery entry and return same object
 */

export const CreateMisdeliveryEntry = async (params: MisdeliveryFormData) => {
    try {
        // Get static headers from map
        const staticHeaders = getTrackingHeadersMap(ApiType.MISDELIVERY_CREATE) || {};
        // Add dynamic values
        const headers = {
            ...staticHeaders,
            "OSD-Reporting-Terminal": params.reportingTerminal,
            "OSD-Origin-Terminal": params.originTerminal,
            "OSD-Destination-Terminal": params.destinationTerminal,
            "OSD-Pickup-Terminal": params.pickupTerminal,
        };
        const { data } = await axios.post(getUrl(ApiType.MISDELIVERY_CREATE), params, { headers });
        return data;
    } catch (error: any) {
        return throwApiError(error, ErrorMessages.createMisdeliveryEntry, { badRequestOrder: "errorsFirst" });
    }
};
